﻿'use strict';

angular.module('ntmApp').factory('ListGridGrouping', ['$timeout', 'ListGridHelper', function ($timeout, ListGridHelper) {

    function ListGridGrouping(groupObj) {

        var self = this;

        self.hasGrouping = function () {
            return groupObj && groupObj.enable;
        };

        self.showAddGroupBtn = function (row) {
            if (!row.groupHeader) {
                return;
            }

            return groupObj.columns.filter(function (item) {
                return item.groupPriority === row.treeLevel;
            })[0].enableAddRow;
        };

        self.getAddRowMargin = function (row) {
            if (!row.groupHeader) {
                return;
            }

            var margin = 0;

            var groupRow = row.treeNode;

            while (groupRow.children.length > 0) {
                groupRow = groupRow.children[0];
            }

            groupObj.columns.forEach(function (item) {

                if (item.groupPriority <= row.treeLevel) {
                    var column = ListGridHelper.getColumnByFieldName(item.column);

                    if (item.groupPriority === row.treeLevel) {

                        var groupColumnValue = groupRow.row.entity[column.name] || 5;
                        margin += (60 + groupColumnValue.length * 8) || 120;

                    } else {

                        var colWidth = 0;
                        row.grid.columns.forEach(function (col) {
                            if (col.field === column.name) {
                                colWidth = col.drawnWidth;
                            }
                        });

                        margin += colWidth || 120;

                    }                    
                }
            });

            return margin || 120;
        };

        self.expandRow = function (gridApi) {
            if (self.hasGrouping()) {
                groupObj.columns.forEach(function (item, $index) {
                    if (item.expanded) {
                        var time = 50 + $index * 500;
                        $timeout(function () {
                            gridApi.core.getVisibleRows().forEach(function (row) {
                                gridApi.treeBase.expandRow(row);
                            });
                        }, time);
                    }
                });
            }
        };

        self.isValidDrop = function (info) {
            var valid = true;

            if (self.hasGrouping() && groupObj.columns && groupObj.columns.length > 0) {
                groupObj.columns.forEach(function (item) {
                    var column = ListGridHelper.getColumnByFieldName(item.column);
                    if (!item.aggregation && column.fieldName === item.column && info.draggedRowEntity[column.name] !== info.targetRowEntity[column.name]) {
                        valid = false;
                    }
                });
            }

            return valid;
        };

        self.getGroupRows = function (grid, row) {
            if (!self.hasGrouping()) {
                return grid.rows;
            }

            return row.treeNode.parentRow.treeNode.children.map(function (item) { return item.row; });
        };

        self.getGroupChildren = function (entity, data) {
            return data.filter(function (record) {
                var contain = true;

                if (!self.hasGrouping() || !entity) {
                    return contain;
                }

                groupObj.columns.forEach(function (item) {
                    var column = ListGridHelper.getColumnByFieldName(item.column);
                    if (!item.aggregation && column.fieldName === item.column && entity[column.name] !== record[column.name]) {
                        contain = false;
                    }
                });

                return contain;
            });
        };

        self.getNullLabel = function () {
            return groupObj ? groupObj.groupingNullLabel : null;
        };

        self.getShowCounts = function () {
            return groupObj ? groupObj.groupingShowCounts : null;
        };

        self.processingGrouping = function (column, columnDefinition) {

            if (!self.hasGrouping()) {
                return;
            }

            groupObj.columns.forEach(function (groupColumn) {
                if (column.fieldName === groupColumn.column) {
                    if (groupColumn.aggregation) {
                        columnDefinition.treeAggregationType = groupColumn.aggregation;
                        columnDefinition.customTreeAggregationFinalizerFn = function (aggregation) {
                            aggregation.rendered = aggregation.value;
                        };
                        return;
                    }

                    columnDefinition.enableHiding = false;
                    columnDefinition.visible = true;

                    columnDefinition.grouping = {
                        groupPriority: groupColumn.groupPriority && groupColumn.groupPriority >= 0 ? groupColumn.groupPriority : 0
                    };
                }
            });
        };

        self.expandRows = function (gridApi, row) {

            gridApi.treeBase.expandRow(row);

        };

        self.expandJustAddedRow = function (gridApi) {

            $timeout(function () {
                gridApi.core.getVisibleRows().forEach(function (row) {
                    if (row.groupHeader) {
                        if (row.entity['$$uiGrid-0006'].groupVal === self.getNullLabel()) {
                            self.expandRows(gridApi, row);

                            var children = row.treeNode.children;
                            while (children.length > 0) {
                                self.expandRows(gridApi, row.treeNode.children[0].row);
                                children = children[0].row.treeNode.children;
                            }

                        } else {
                            gridApi.treeBase.collapseRow(row);
                        }
                    }
                });
            }, 100);

        };

        self.getSampleRowData = function (groupRow) {

            var columns = getColumnsByGroupLevel(groupRow.treeLevel);

            groupRow = groupRow.treeNode;

            while (groupRow.children.length > 0) {
                groupRow = groupRow.children[0];
            }

            var sampleRow = ListGridHelper.createEmptyRecord(true, groupRow.row.entity);

            columns.forEach(function (groupColumn) {

                if (groupColumn.enableAddRow) {

                    var column = ListGridHelper.getColumnByFieldName(groupColumn.column);
                    sampleRow[column.name] = groupRow.row.entity[column.name];

                    if (column.propertyObj.key && column.propertyObj.key !== column.fieldName) {
                        column = ListGridHelper.getColumnByFieldName(column.propertyObj.key);
                        sampleRow[column.name] = groupRow.row.entity[column.name];
                    }
                }

            });

            return sampleRow;
        };

        function getColumnsByGroupLevel(level) {

            return groupObj.columns.filter(function (item) {
                return !item.groupPriority || item.groupPriority <= level;
            });
        }

    }

    return (ListGridGrouping);
}]);